const primaryButtonStyle = () => ({
	position: 'relative',
	overflow: 'hidden',
	color: '#fff',
	backgroundColor: '#ff8f00',
	background: 'linear-gradient(90deg, #FF8F00 0%, #F86605 100%)',
	border: 'none',
	borderRadius: 12,
	fontWeight: 700,
	fontFamily: 'Spartan, sans-serif',
	textTransform: 'initial',
	cursor: 'pointer',
	textAlign: 'center',
	'&::before': {
		content: '""',
		display: 'block',
		position: 'absolute',
		inset: 0,
		background: 'linear-gradient(90deg, #CC7200 0%, #C65204 100%)',
		opacity: 0,
		transition: 'opacity 0.3s ease',
		zIndex: 0,
	},
	'&:hover': {
		backgroundColor: '#C65204',
	},
	'&:hover::before': {
		opacity: 1,
	},
	'&>span': {
		color: '#ffffff',
		display: 'inline-flex',
		alignItems: 'center',
		position: 'relative',
		zIndex: 1,
	},
	'&.Mui-disabled': {
		color: '#ffffff',
		background: '#d4d6d7',
	},
});

export default primaryButtonStyle;